import React from "react";

export default function Footer() {
  return (
    <div id="footer">
      <h4>All Rights Reserved</h4>
    </div>
  );
}
